/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const REQUESTED_PORTFOLIO = 'REQUESTED_PORTFOLIO';
export const requestedPortfolio = () => ({
  type: REQUESTED_PORTFOLIO
});

export const RECEIVED_PORTFOLIO = 'RECEIVED_PORTFOLIO';
export const receivedPortfolio = (portfolio) => ({
  type: RECEIVED_PORTFOLIO,
  portfolio
});

export const ERROR_PORTFOLIO = 'ERROR_PORTFOLIO';
export const errorPortfolio = () => ({
  type: ERROR_PORTFOLIO
});
